export default "__VITE_ASSET__dgOxCeTw__"